import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FeatherIconsComponent } from '../../feather-icons/feather-icons.component';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-profile',
  imports: [FeatherIconsComponent, RouterModule],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  public isShow: boolean = false;

  constructor(
    public router: Router,
    private authService: AuthService
  ) {}

  logOut() {
    this.authService.logoutApi().subscribe({
      next: () => {
        this.authService.logout();
      },
      error: (error) => {
        console.error('Error on logout', error);
      }
    });
  }
}
